export default class FeedbackWidget {

    constructor(widgetEl) {
        this.widget = widgetEl;
    }

    init() {
        $('.emoji-face').on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).css({
                backgroundColor: '#ff6600'
            }).find('a').css('color', '#ffffff');
            setTimeout(() => { this.showPoll() }, 1000);
        });
        $('.feedback-close').click(() => {
            this.widget.remove();
        });
    }

    showPoll() {
        this.widget.find('.first-step').hide();
        this.widget.find('.second-step').show();
    }
}
